// extracted by mini-css-extract-plugin
export var alignLeft = "t_rd d_fp d_bG d_dv";
export var alignCenter = "t_bP d_fq d_bD d_dw";
export var alignRight = "t_rf d_fr d_bH d_dx";
export var customRow = "t_pb d_bD d_Z";